export default __webpack_public_path__ + "static/HenryNetzer-cfd2ce75eb60cc99f2b817eab29a78e6.jpg";